// extracted by mini-css-extract-plugin
export var image = "cj_dj";